import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'


import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'



import { showModalSelector, selectFromSelector, downloadFile } from '../../actions/common'


import {
    updateInputs,
    addCotizacion,
    addProveedorCotizacion,
    removeProveedorCotizacion
} from '../../actions/solicitudservicio'


import { isAllowedToViewComponent } from '../../utils/helpers'


class Proveedores extends Component {

    handleOpenSelectorProveedor = (list) => {

        let columns = [
            { id: 1, caption: 'Nit', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Razon Social', value: 'nombre', width: '70%' }   
        ]
        const payload = {}

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector(() => this.props.addProveedorCotizacion(payload));
        }

        this.props.showModalSelector('Listado de proveedores', columns, `/proveedores`, fn)
    }

    

	render() {

        const { id, solicitudservicio, estado } = this.props
        const yesterday = moment().subtract('days', 1)
        //const yesterday = moment().add('days', 2)
        const fueraLimiteCotizaciones = moment(solicitudservicio.getIn(['servicios', 0, 'fecha_cotizaciones'])).isAfter(yesterday)

        if (!id) return null


        const servicio_id = solicitudservicio.getIn(['servicios', 0, 'id']) ? solicitudservicio.getIn(['servicios', 0, 'id']) : 0

        const readOnly = !isAllowedToViewComponent('responsable_compras', this.props.solicitudservicio) 
        

		return (
            <div>

                <BoxSection title="Informacion básica para las cotizaciones"> 


                    <div className="row">


                        <div className="col-md-2">
                        
                            <div className="form-group">
                                <label className="control-label">Fecha límite cotizaciones</label>
                                <input 
                                    type="date" 
                                    className="form-control input-sm" 
                                    value={ 
                                        solicitudservicio.getIn(['servicios', 0, 'fecha_cotizaciones']) !== '-0001-11-30 00:00:00' ? 
                                            moment(solicitudservicio.getIn(['servicios', 0, 'fecha_cotizaciones'])).format('YYYY-MM-DD') : '' 
                                        } 
                                    onChange={ (e) => this.props.updateInputs(`solicitud.servicios.0.fecha_cotizaciones`, e.target.value, solicitudservicio.getIn(['servicios', 0, 'id'])) } 
                                    
                                />
                            </div>                        
                        
                        </div>
                    
                    
                    </div>
                
                
                
                
                </BoxSection>

                <div className="separator"></div>

                {
                    solicitudservicio.get('servicios').map((x, n) => {
                        return (
                            <BoxSection key={ x.get('id') } title={ `Servicio No ${n + 1}` }>   

                                <div className="row">

                                    <div className="col-md-5">

                                        <div className="row">
                                            <div className="col-md-12">                                            
                                                <div className="form-group">
                                                    <label className="control-label">Descripción</label>
                                                    <textarea id="Descripcion" className="form-control input-sm" value={  x.get('descripcion')  } rows={ 3 } disabled />
                                                </div>                                            
                                            </div>                                        
                                        </div>

                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label className="control-label">Cantidad</label>
                                                    <input type="number" className="form-control input-sm" value={ x.get('cantidad') } disabled />
                                                </div> 
                                            </div>
                                        </div>                                    
                                    
                                    </div>


                                    <div className="col-md-7">
 
                                        <div className="box-content" style={{ overflowX: 'hidden' }}>
                                            <table className="table table-condensed">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={4}>
                                                            <span style={{ lineHeight: '19px' }}>Proveedores con solicitud de cotización</span>
                                                            <span style={{ float: 'right' }}>
                                                                <BoxButton key={`pa[${n}][0]`} size={14} name="plus-circle" onClick={ () => this.props.addCotizacion(`solicitud.servicios.${n}.cotizaciones`, n) } title="Adicionar" disabled={!fueraLimiteCotizaciones || x.get('estado') == 0 || x.get('estado') >= 2 || readOnly }/>
                                                                <BoxButton key={`pa[${n}][1]`} size={14} name="trash" onClick={ () => this.props.removeProveedorCotizacion(`solicitud.servicios.${n}.cotizaciones`) } title="Eliminar" disabled={ solicitudservicio.getIn(`solicitud.servicios.${n}.cotizaciones`.split('.').splice(1)).filter(x => x.get('selected')).count() === 0 || x.get('estado') == 0 || x.get('estado') >= 2 || !fueraLimiteCotizaciones  || readOnly}  />
                                                            </span>
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th style={{ width: '20px' }}><input type="checkbox" /></th>
                                                        <th  style={{ width: '50%' }}>Nombre</th>
                                                        <th  style={{ width: '50%' }}>Descargar cotización</th>
                                                    </tr>
                                                </thead>
                                                <tbody>                                                    
                                                    {                    
                                                    //.filter(c => c.get('proveedor_id')!== null)                                                                               
                                                        x.get('cotizaciones').map((a, b) => {

                                                            const fileid = a.get('adjunto_id') ? a.getIn(['adjunto', 'id']) : null
                                                            const filename = a.get('adjunto_id') ? a.getIn(['adjunto', 'nombre']) : null

                                                            return (                                                                
                                                                <tr key={ `tr3[${a.get('guid')}]` } className={ a.get('selected') ? 'info-dark' : '' }>
                                                                    <td><input type="checkbox" style={{ marginTop: '6px' }} value={ a.get('selected') } onChange={ (e) => this.props.updateInputs(`solicitud.servicios.${n}.cotizaciones.${b}.selected`, e.target.checked) } disabled={x.get('estado') == 0 || x.get('estado') >= 2}  /></td>
                                                                    <td>
                                                                        {
                                                                            (solicitudservicio.getIn(['servicios', n, 'cotizaciones', b, 'estado']) == 1 && !a.getIn(['adjunto', 'id']) && fueraLimiteCotizaciones) ? (
                                                                                <SelectorInput value={ a.getIn(['proveedore', 'nombre']) ? a.getIn(['proveedore', 'nombre']) : '' } onClick={ () => this.handleOpenSelectorProveedor(`solicitud.servicios.${n}.cotizaciones.${b}.proveedore`) } onReset={ () => null } />
                                                                            ) : (
                                                                                <input className="form-control input-sm" value={ a.getIn(['proveedore', 'nombre']) ? a.getIn(['proveedore', 'nombre']) : '' } disabled />
                                                                            )
                                                                        }                                                                                
                                                                    </td>
                                                                    
                                                                    {
                                                                        a.get('adjunto_id') ? (
                                                                            <td style={{ cursor: 'pointer' }} onClick={ a.get('adjunto') ? () => this.props.downloadFile(fileid, filename) : () => null }>
                                                                                <i className="fa fa-download"></i>
                                                                                <span style={{ marginLeft: '3px' }}>{`${a.getIn(['adjunto', 'nombre'])}`}</span>                                                                                                               
                                                                            </td>
                                                                        ) : (  
                                                                            <td style={{ cursor: 'not-allowed' }}>
                                                                                <span style={{ marginLeft: '3px' }}>{fileid ? `${a.getIn(['adjunto', 'nombre'])}` : 'Archivo sin adjuntar'}</span>
                                                                            </td>                                                          
                                                                        )
                                                                    }


                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    
                                                </tbody>
                                            </table>
                                            <table>  
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <input  style={{ marginLeft: '4px' }}
                                                                type="checkbox"                                                                                            
                                                                disabled={readOnly || (x.get('cantidad') == 0)} 
                                                                checked={ x.get('compra_directa') }
                                                                onChange={ (e) => this.props.updateInputs(`solicitud.servicios.${n}.compra_directa`, e.target.checked, x.get('id')) } 
                                                        />
                                                    </td>
                                                    <td style={{ paddingLeft: '5px'}}> Compra Directa </td>                                                       
                                                </tr>
                                                </tbody>
                                            </table>    
                                        </div>
                                    </div>
                                </div>
                            </BoxSection>
                        )
                    })
                }
                
                <ModalSelectorFromList />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudservicio.get('id'),
        estado: state.solicitudservicio.get('estado'),
        solicitudservicio: state.solicitudservicio.get('solicitud'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)), 
        addCotizacion: (path, indexServicio) => dispatch(addCotizacion(path, indexServicio)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        addProveedorCotizacion: (payload) => dispatch(addProveedorCotizacion(payload)),
        removeProveedorCotizacion: (path) => dispatch(removeProveedorCotizacion(path)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Proveedores)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/Proveedores.jsx